import type { Dict } from './index';

// Almanca sözlük — Claude tarafından elle çevrildi (06.08.2026), makine
// çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const de: Dict = {
  map: {
    title: "Geteilte Standorte",
    hint: "Nur aktive, ausdrücklich mit dir geteilte Standorte. Der letzte Punkt ist nicht unbedingt aktuell.",
    empty: "Keine aktiven Standorte mit dir geteilt.",
    waiting: "Warten auf einen Standortpunkt.",
    error: "Standorte konnten nicht geprüft werden. Erneut versuchen.",
    providerError: "Die Karte konnte nicht geladen werden. Die Standortliste bleibt verfügbar.",
    fit: "Alle anzeigen",
    lastPoint: "Letzter Standort: {time}",
    unknown: "Person ohne Namen",
  },
  visit: {
    title: "Besuchseinladung",
    incoming: "Diese Person lädt dich zu einem Besuch ein.",
    hint: "Eine widerrufbare Einladung nur für diese Person. Dein Standort wird nicht geteilt; es handelt sich weder um eine Buchung noch um eine Zusage der anderen Person.",
    place: "Ort",
    time: "Zeit",
    defaultPlace: "Mein Standort",
    defaultTime: "Jederzeit",
    enabled: "Diese Person ist zu einem Besuch eingeladen.",
    off: "Du hast keine offene Einladung für diese Person.",
    edit: "Ort und Zeit bearbeiten",
    save: "Einladung speichern und aktivieren",
    revoke: "Einladung widerrufen",
    unavailable: "Einladung nicht verfügbar. Ein Gespräch muss bereits bestehen; erneut prüfen.",
  },
  signInMethods: {
    // D-871 — the linked Google accounts, and removing one.
    googleAccountUnknown: "Google-Konto (Adresse noch unbekannt)",
    googleLinkedDate: "Verknüpft am {date}",
    googleRemove: "Entfernen",
    googleRemoveTitle: "Dieses Google-Konto entfernen?",
    googleRemoveBody: "Du bestätigst zuerst deine hinterlegte Nummer. Danach kann sich dieses Google-Konto nicht mehr bei nosubject anmelden.",
    googleRemoveConfirm: "Gib den Code ein, um {account} zu entfernen.",
    googleRemoved: "Google-Konto entfernt.",
    googleLastMethod: "Das ist der einzige Weg, dich bei diesem Account anzumelden. Er kann nicht entfernt werden.",
    googleAddAnother: "Weiteres Google-Konto verknüpfen",
    googleLinkedCount: "Verknüpfte Google-Konten: {count}",
    googleLinked: "Google-Konto verknüpft.",
    googleCodeSent: "Ein Code wurde an deine hinterlegte Nummer mit der Endung {phone} gesendet.",
    googleChooseHint: "Das ausgewählte Google-Konto wird für die Anmeldung bei diesem nosubject-Konto verknüpft.",
    googleStatusUnknown: "Der Google-Verbindungsstatus konnte nicht geprüft werden. Bitte prüfe ihn erneut.",
    googleLinkIntro: "Bestätige zuerst die hinterlegte Telefonnummer dieses Kontos, um Google zu verknüpfen.",
    googleLinkFailed: "Die Anfrage konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
    googleSendCode: "Bestätigungscode senden",
    googleCodeLabel: "Bestätigungscode",
    googleStartAgain: "Neu beginnen",
    googleContinue: "Mit Google fortfahren",
    googleFailed: "Die Anmeldung mit Google konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
    googleNotLinked: "Dieses Google-Konto ist noch nicht mit einem nosubject-Konto verknüpft.",
    googleUnavailable: "Die Anmeldung mit Google ist noch nicht verfügbar.",
    title: "Anmeldemethoden",
    intro: "Dieser Bereich wird vorbereitet. Optionen zum Verwalten der Anmeldemethoden werden später hinzugefügt.",
    identity: "Identitätsprüfung",
    identityInfo: "Die Prüfung deiner Identität ist von der Anmeldung bei deinem Konto getrennt.",
  },
  safety: {
    title: 'Sicherheitsnummer',
    compare: 'Vergleiche diese Nummer mit {name}. Wenn sie übereinstimmt, kann niemand dazwischen die Nachrichten lesen.',
    explainInfo: 'Die Nummer entsteht aus den Verschlüsselungsschlüsseln aller aktuellen Geräte beider Personen und ist auf beiden Handys gleich. Fügt eine der beiden ein Gerät hinzu, etwa ein neues Handy oder das Web, ändert sich die Nummer. Vergleiche sie dann erneut. Die Bestätigung wird nur auf diesem Gerät gespeichert.',
    qrLabel: 'QR-Code der Sicherheitsnummer',
    verified: 'Verifiziert',
    notVerified: 'Nicht verifiziert',
    markVerified: 'Als verifiziert markieren',
    clearVerified: 'Verifizierung entfernen',
    peerUnavailable: 'Die Verschlüsselung ist mit dieser Person noch nicht aktiv.',
    selfUnavailable: 'Der Verschlüsselungsschlüssel dieses Geräts ist noch nicht bereit.',
    loadFailed: 'Die Sicherheitsnummer konnte nicht geladen werden.',
  },
  backup: {
    title: 'Chat-Backup',
    explainInfo: 'Dein Verlauf liegt auf diesem Gerät. Das Backup verschlüsselt ihn mit deinem Wiederherstellungscode und legt ihn auf dem Server ab; wir können es nicht öffnen.',
    create: 'Backup erstellen',
    refresh: 'Backup aktualisieren',
    codeTitle: 'Dein Wiederherstellungscode',
    codeWarning: 'Bewahre diesen Code sicher auf. Geht er verloren, kommt dein Verlauf nicht zurück, und auch wir können ihn nicht öffnen.',
    restoreTitle: 'Verlauf wiederherstellen',
    restorePlaceholder: 'Wiederherstellungscode',
    restore: 'Wiederherstellen',
    restored: '{count} Nachrichten wiederhergestellt.',
    restoreFailed: 'Verlauf konnte nicht geöffnet werden. Prüfe den Code.',
    failed: 'Backup fehlgeschlagen.',
  },
  common: {
    clear: "Suche löschen",
    infoHide: 'Erklärung ausblenden: {subject}',
    infoShow: 'Erklärung anzeigen: {subject}',
    continue: 'Weiter',
    cancel: 'Abbrechen',
    close: 'Schließen',
    save: 'Speichern',
    done: 'Fertig',
    retry: 'Erneut versuchen',
    error: 'Fehler',
    back: 'Zurück',
    search: 'Suchen…',
    loading: 'Wird geladen',
    remove: 'Entfernen',
    offline: 'Der Server ist nicht erreichbar. Prüfe deine Verbindung.',
    sessionExpired: 'Deine Sitzung ist abgelaufen. Melde dich erneut an.',
    tooManyRequests: 'Zu viele Anfragen. Warte kurz und versuch es erneut.',
  },
  time: {
    now: 'gerade eben',
    minAgo: 'vor {n} Min.',
    hourAgo: 'vor {n} Std.',
    yesterday: 'gestern',
    dayAgo: 'vor {n} Tagen',
    weekAgo: 'vor {n} Wochen',
    weekAgoOne: 'vor {n} Woche',
    today: 'Heute',
    dayYesterday: 'Gestern',
  },
  phone: {
    sendFailed: "Der Code konnte nicht gesendet werden. Versuch es erneut.",
    subtitle: 'Gib deine Telefonnummer ein',
    selectCountry: 'Land / Region',
    countrySearch: 'Land suchen…',
    architectureLink: 'Technische Architektur und Roadmap ↗',

  },
  otp: {
    verifyFailed: "Der Code konnte nicht überprüft werden. Versuch es erneut.",
    invalidCode: "Der Code ist ungültig oder abgelaufen.",
    rateLimited: "Zu viele Versuche. Versuch es später erneut.",
    title: 'Code eingeben',
    sentTo: 'Wir haben eine SMS an {phone} gesendet',
    verify: 'Bestätigen',
    resend: 'Erneut senden',

    tooManyAttempts: 'Zu viele Versuche. Warte kurz und versuch es erneut.',

    resendSent: 'Ein neuer Code wurde gesendet.',
    resendFailed: 'Der Code konnte nicht gesendet werden. Prüfe deine Verbindung und versuch es erneut.',
    resendWait: 'Du kannst in {n} s erneut anfordern',
  },
  university: {
    title: 'Welche Universität?',
    subtitle: 'Suche nach deiner Universität',
    placeholder: 'Harvard, Oxford…',
    skip: 'Überspringen',
  },
  profession: {
    title: 'Was machst du beruflich?',
    subtitle: 'Suche deinen Beruf',
    placeholder: 'Lehrer, Entwickler, Krankenpfleger…',
    skip: 'Überspringen',
  },
  isco: {
    '0': 'Streitkräfte',
    '1': 'Führungskräfte',
    '2': 'Akademische Berufe',
    '3': 'Techniker und gleichrangige nichttechnische Berufe',
    '4': 'Bürokräfte und verwandte Berufe',
    '5': 'Dienstleistungsberufe und Verkäufer',
    '6': 'Fachkräfte in Land-, Forst- und Fischereiwirtschaft',
    '7': 'Handwerks- und verwandte Berufe',
    '8': 'Anlagen- und Maschinenbediener',
    '9': 'Hilfsarbeitskräfte',
  },
  isced: {
    '5': 'Fachschule',
    '6': 'Bachelor',
    '7': 'Master',
    '8': 'Promotion',
  },
  profileCreate: {
    photoPickerFailed: "Die Fotomediathek konnte nicht geöffnet werden.",
    title: 'Erstelle dein Profil',
    addPhoto: 'Foto hinzufügen',
    name: 'Dein Vorname',
    surname: 'Dein Nachname',
  },
  terms: {
    title: 'Bevor du startest',
    age: 'Ich bin über 18 Jahre alt',
    accept: 'Ich habe die Nutzungsbedingungen und die Datenschutzrichtlinie gelesen und akzeptiere sie',
    termsLink: 'Nutzungsbedingungen',
    privacyLink: 'Datenschutzrichtlinie',
    continue: 'Akzeptieren und fortfahren',
    saveFailed: 'Deine Zustimmung konnte nicht gespeichert werden. Prüfe deine Verbindung und versuche es erneut.',
    docPlaceholder: 'Dieses Dokument wird bald veröffentlicht.',
  },
  locationConsent: {
    title: 'Standort – nur wenn du möchtest',
    body: 'Damit wir nach einer Fotoaufnahme Bezirk und Stadt vorschlagen können, benötigen wir die Standortberechtigung.',
    privacy: 'In diesem Schritt wird dein Standort nicht abgerufen. Er wird nur nach einer erfolgreichen Aufnahme verwendet; deine genauen Koordinaten werden nicht gespeichert. Du kannst die Berechtigung später in den Geräteeinstellungen ändern.',
    allow: 'Standort erlauben',
    later: 'Jetzt nicht',
  },
  discover: {
    title: "Entdecken",
    categories: "Berufskategorien",
    categoryHint: "Entdecke Menschen anhand der Berufe in ihren Profilen.",
    all: "Alle",
    reset: "Filter löschen",
    failed: 'Konnte nicht geladen werden',
    free: 'Kostenlos',
    empty: 'Hier ist noch niemand',
  },
  userProfile: {
    smsVerifiedOn: "Telefon per SMS bestätigt · {date}",
    googleLinkedOn: "Google-Konto verknüpft · {date}",
    contactProofNote: "Bestätigt den Zugriff auf ein Telefon oder Google-Konto, nicht die Identität einer Person.",
    failed: 'Profil konnte nicht geladen werden',
    sendMessage: 'Nachricht senden',
    buyTime: 'Treffen vorschlagen',
    block: 'Blockieren',
    blockedNotice: '{name} ist blockiert. Nachrichten, Anrufe und Treffen sind deaktiviert.',
    blockTitle: '{name} blockieren?',
    blockMessage: 'Diese Person kann dir keine Nachrichten mehr senden und dich nicht mehr in der Entdecken-Ansicht finden.',
    blockConfirm: 'Blockieren',
  },
  callHistory: {
    empty: 'Noch keine Anrufe',
    tabAll: 'Alle',
    tabMissed: 'Verpasst',
    emptyMissed: 'Keine verpassten Anrufe',
    failed: 'Anrufe konnten nicht geladen werden',
    outgoing: 'Ausgehend',
    incoming: 'Eingehend',
    missed: 'Verpasst',
    declined: 'Abgelehnt',
    cancelled: 'Abgebrochen',
  },
  call: {
    title: 'Sprachanruf',
    calling: 'Anruf läuft…',
    incoming: 'Eingehender Anruf',
    connecting: 'Verbindung wird hergestellt…',
    connected: 'Verbunden',
    reconnecting: 'Verbindung wird wiederhergestellt…',
    logAnswered: 'Sprachanruf',
    logAnsweredVideo: 'Videoanruf',
    logNoAnswer: 'Keine Antwort',
    logMissed: 'Verpasster Anruf',
    logDeclined: 'Anruf abgelehnt',
    logYouDeclined: 'Du hast den Anruf abgelehnt',
    logCancelled: 'Anruf abgebrochen',
    ended: 'Anruf beendet',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    hangUp: 'Auflegen',
    close: 'Schließen',
    mute: 'Mikrofon aus',
    unmute: 'Mikrofon an',
    cameraOff: 'Kamera aus',
    cameraOn: 'Kamera an',
    flipCamera: 'Kamera wechseln',
    audioOutput: 'Audioausgabe: {route}',
    audioOutputTitle: 'Audioausgabe auswählen',
    earpiece: 'Hörer',
    speaker: 'Lautsprecher',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'Bluetooth-Berechtigung ist aus. Schalte sie in den Einstellungen ein.',
    micPermission: 'Für Anrufe ist Mikrofonzugriff nötig. Schalte ihn in den Einstellungen ein.',
    micPermissionWeb: 'Für Anrufe ist Mikrofonzugriff nötig. Erlaube ihn in den Website-Einstellungen deines Browsers.',
    wiredHeadset: 'Kabelgebundenes Headset',
    audioRouteFailed: 'Audioausgabe konnte nicht geändert werden',
    acceptFailed: 'Der Anruf konnte nicht angenommen werden. Versuch es erneut.',
    declineFailed: 'Der Anruf konnte nicht abgelehnt werden. Versuch es erneut.',
    endFailed: 'Der Anruf konnte nicht beendet werden. Versuch es erneut.',
    mediaConnectionFailed: 'Die Audioverbindung konnte nicht hergestellt werden. Der Anruf wurde nicht berechnet.',
    remaining: 'Noch {time}',
    endingSoon: 'Dieser Anruf endet in Kürze.',
    spent: '{amount} ausgegeben',
    earned: '{amount} verdient',
    noAudioNotice: 'Diese Version überträgt noch keinen Ton. Anrufablauf und Abrechnung werden getestet.',
    failed: 'Anruf konnte nicht gestartet werden',
    insufficient: 'Dein Guthaben reicht für diesen Anruf nicht',
    busy: 'Die Person telefoniert gerade',
    notAllowed: 'Vor dem Anruf muss es mindestens eine Nachricht zwischen dir und dieser Person geben',
    notAccepting: 'Diese Person nimmt derzeit keine Anrufe an',
    priceFree: 'Kostenlos',
    priceChanged: 'Der Anrufpreis hat sich geändert. Sieh dir den neuen Preis an und versuch es erneut.',
    rateLimited: 'Du hast zu viele Anrufversuche unternommen. Warte kurz und versuche es erneut.',
    reservationLinkUnavailable: 'Diese Buchung kann nicht mehr mit dem Anruf verknüpft werden. Du kannst stattdessen einen normalen Anruf starten.',
    missed: 'Verpasster Anruf',
    callNow: 'Jetzt anrufen',
    videoNow: 'Jetzt per Video anrufen',
    scheduledStartTitle: 'Geplanter Anruf',
    scheduledStartBody: 'Dein geplanter Anruf mit {name} beginnt. Jetzt anrufen?',
    schedule: 'Anruf planen',
    scheduleTitle: 'Anruf mit {name} planen',
    subjectPlaceholder: 'Betreff (optional)',
    priceNote: 'Anrufpreis: {price}',
    sendReservation: 'Buchungsanfrage senden',
    reservationSent: 'Anfrage gesendet',
    reservationSentBody: 'Deine Anrufbuchungsanfrage wurde an {name} gesendet.',
    reservationFailed: 'Buchungsanfrage für den Anruf konnte nicht gesendet werden',
    reservationBubble: '☎️ Anrufbuchung angefragt',
    reservationBubbleShort: '☎️ Anrufbuchung',
    reservationLabel: 'Sprachanruf-Buchung',
    rescheduleBubble: '☎️ Neue Anrufzeit vorgeschlagen',
    rescheduleBubbleShort: '☎️ Neue Anrufzeit',
  },
  wallet: {
    otherAmount: "Anderer Betrag",
    customAmount: "Betrag",
    customAmountHint: "Bis zu {amount}; höchstens zwei Nachkommastellen.",
    title: 'Wallet',
    failed: 'Wallet konnte nicht geladen werden',
    availableBalance: 'Verfügbares Guthaben',
    earningsTitle: 'Meine Einnahmen',
    earningsTotal: 'Insgesamt verdient',
    earningsWithdrawable: 'Zur Auszahlung verfügbar',
    earningsEscrow: 'Auf dem Treuhandkonto',
    addFunds: 'Guthaben aufladen',
    addFundsDemo: 'Demo: Testguthaben zu deinem Konto hinzufügen',
    addFundsFailed: 'Guthaben konnte nicht hinzugefügt werden.',
    topupLabel: 'Guthaben aufgeladen',
    transactions: 'Transaktionen',
    noTransactions: 'Noch keine Transaktionen',
    waiting: 'ausstehend',
    incomingRequest: 'eingehende Anfrage',
    replied: 'beantwortet',
    earned: 'verdient',
    refunded: 'Erstattet',
    requestPayout: 'Auszahlen',
    payoutHint: 'Du kannst bis zu {amount} auszahlen lassen.',
    payoutAll: 'Gesamten Betrag auswählen',
    payoutRequested: 'Anfrage erhalten',
    payoutRequestedBody: 'Eine Auszahlungsanfrage über {amount} wurde erstellt und wird in Kürze bearbeitet.',
    payoutFailed: 'Auszahlungsanfrage konnte nicht erstellt werden',
    payoutRequests: 'Auszahlungsanfragen',
    noPayouts: 'Noch keine Auszahlungsanfragen',
    payoutStatusPending: 'Ausstehend',
    payoutStatusPaid: 'Ausgezahlt',
    payoutStatusRejected: 'Abgelehnt',
    paymentAccount: 'Zahlungskonto',
    stripeConnect: 'Zahlungskonto verbinden',
    stripeConnectInfo: 'Verbinde dein Bankkonto, um Einnahmen zu erhalten (Stripe, Testmodus)',
    stripeConnected: 'Verbunden',
    stripeConnectFailed: 'Verbindung fehlgeschlagen',
  },
  calendar: {
    dateInputLabel: "Datum",
    timeInputLabel: "Uhrzeit",
    dateInputHint: "Gib Jahr, Monat und Tag im Format YYYY-MM-DD ein.",
    timeInputHint: "Gib die Uhrzeit im 24-Stunden-Format HH:MM ein.",

    previousWeek: 'Vorherige Woche',
    nextWeek: 'Nächste Woche',
    empty: 'Keine Anfragen zum Anzeigen',
    failed: 'Kalender konnte nicht geladen werden',
    statusPending: 'Ausstehend',
    statusAccepted: 'Angenommen',
    statusDeclined: 'Abgelehnt',
    statusCancelled: 'Storniert',
    statusExpired: 'Abgelaufen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    cancel: 'Stornieren',
    cancelConfirmationTitle: 'Reservierung stornieren?',
    cancelConfirmationAcceptedBody: 'Die bestätigte Reservierung mit {name} wird storniert. Die andere Person wird benachrichtigt. Dies kann nicht rückgängig gemacht werden.',
    cancelConfirmationPendingBody: 'Der an {name} gesendete Vorschlag wird zurückgezogen. Die andere Person wird benachrichtigt. Dies kann nicht rückgängig gemacht werden.',
    actionFailed: 'Aktion fehlgeschlagen',
    proposeTitle: 'Treffen mit {name} vorschlagen',
    locationPlaceholder: 'Wo? (optional)',
    sendProposal: 'Vorschlag senden',
    proposalSent: 'Vorschlag gesendet',
    proposalSentBody: 'Dein Treffenvorschlag wurde an {name} gesendet.',
    priceChangedBody: 'Der Minutenpreis für diese Reservierung beträgt jetzt {amount}. Es wurde kein Vorschlag erstellt — sieh dir den neuen Preis an und sende einen neuen Vorschlag.',
    proposalFailed: 'Vorschlag konnte nicht gesendet werden',
    meetupBubble: '📅 Treffen vorgeschlagen',
    meetupBubbleShort: '📅 Treffenvorschlag',
    proposeAction: '📅 Treffen vorschlagen',
    priceNote: 'Tarif für das Treffen: {price}',
    totalCost: 'Gesamt: {amount}',
    minutesShort: 'Min',
    tabRequests: 'Anfragen',
    tabCalendar: 'Kalender',
    tabActive: 'Aktuell',
    tabHistory: 'Verlauf',
    loadMore: 'Mehr anzeigen',
    noEventsForDay: 'Keine Termine an diesem Tag',
    meetupLabel: 'Persönliches Treffen',
    reservationDetails: 'Reservierungsdetails',
    reservationParticipant: 'Person',
    reservationHeld: 'Anruf fand statt',
    reservationNotHeld: 'Kein Anruf erfolgt',
    reservationDateTime: 'Datum und Uhrzeit',
    reservationDuration: 'Dauer',
    reservationRate: 'Pro Minute',
    reservationLocation: 'Ort',
    reservationSubject: 'Thema',
    reservationQuotedTotal: 'Angebotssumme',
    reservationBilledDuration: 'Abgerechnete Dauer',
    reservationSpentAmount: 'Gezahlter Betrag',
    reservationEarnedAmount: 'Verdienter Betrag',
    reservationSettledAt: 'Abgerechnet',
    reservationCreated: 'Erstellt',
    reservationResponded: 'Beantwortet',
    reservationAcceptedAt: 'Angenommen',
    reservationDeclinedAt: 'Abgelehnt',
    reservationCancelledAt: 'Storniert',
    reservationCancelledBy: 'Storniert von',
    reservationYou: 'Dir',
    reservationCancellationNotification: 'Benachrichtigungsversand',
    reservationNotificationPending: 'Wird vorbereitet',
    reservationNotificationProviderAccepted: 'Vom Versanddienst angenommen',
    reservationNotificationSuppressed: 'Wegen der Benachrichtigungseinstellungen nicht gesendet',
    reservationNotificationUnavailable: 'Kein geeignetes Gerät gefunden',
    reservationPendingReschedule: 'Vorgeschlagene neue Zeit',
    reservationNewTime: 'Neues Datum und neue Uhrzeit',
    proposeNewTime: 'Neue Zeit vorschlagen',
    rescheduleFuture: 'Die neue Zeit muss in der Zukunft liegen und sich um mindestens eine Minute von der bisher geplanten Startzeit unterscheiden.',
    reservationCallTooEarly: 'Dieser geplante Anruf ist 15 Minuten vor Beginn verfügbar.',
    reservationCallExpired: 'Das Anruffenster für diese Buchung ist beendet.',
    reservationCallInProgress: 'Der mit dieser Buchung verknüpfte Anruf wurde bereits gestartet.',
    reservationExecutionLocked: 'Dieser geplante Anruf kann nicht mehr geändert werden, da er begonnen hat oder beendet ist.',
    openReservation: 'Reservierungsdetails mit {name} öffnen',
    systemEventMeetupTitle: 'Treffen mit {name}',
    systemEventCallTitle: 'Geplanter Anruf mit {name}',
    systemEventNotes: 'Über nosubject bestätigt.',
    systemCalendarCopyRemoved: 'Systemkalenderkopie wurde gelöscht',
    restoreSystemCalendarCopy: 'Wiederherstellen',
    systemCalendarRestoreFailed: 'Die Kalenderkopie konnte nicht wiederhergestellt werden. Prüfe Kalenderverbindungen und Systemberechtigung.',
    systemCalendarCopyChanged: 'Die Zeit im Systemkalender wurde geändert',
    reviewSystemCalendarChange: 'Prüfen',
    systemCalendarChangeTitle: 'Kalenderzeit geändert',
    systemCalendarChangeBody: 'Diese Änderung wurde nicht auf die andere Person übertragen.\n\nnosubject: {nosubject}\nSystemkalender: {system}',
    restoreNosubjectTime: 'nosubject-Zeit wiederherstellen',
    systemCalendarTimeRestoreFailed: 'Die Zeit der Kalenderkopie konnte nicht korrigiert werden. Prüfe Kalenderverbindungen und Systemberechtigung.',
    proposeReschedule: 'Der anderen Person vorschlagen',
    rescheduleSent: 'Neue Zeit vorgeschlagen',
    rescheduleSentBody: 'Deine neue Zeit wurde an {name} gesendet. Die aktuelle Zeit bleibt bis zur Annahme bestehen.',
    rescheduleFailed: 'Die neue Zeit konnte nicht vorgeschlagen werden.',
    rescheduleActionFailed: 'Der Zeitvorschlag konnte nicht aktualisiert werden.',
    reschedulePendingReceived: 'Vorgeschlagene neue Zeit: {time}',
    reschedulePendingSent: 'Neue Zeit wartet auf Antwort: {time}',
    withdrawReschedule: 'Vorschlag zurückziehen',
    rescheduleBubble: '📅 Neue Treffzeit vorgeschlagen',
    rescheduleBubbleShort: '📅 Neue Treffzeit',
    connectionsTitle: 'Kalenderverbindungen',
    connectionsInfo: 'Wähle die anzuzeigenden Kalender aus',
    deviceCalendar: 'Gerätekalender',
    connect: 'Verbinden',
    openSettings: 'Einstellungen öffnen',
    permissionGranted: 'Zugriff erlaubt',
    permissionDenied: 'Zugriff deaktiviert',
    permissionUnavailable: 'In dieser Version nicht verfügbar',
    permissionNotRequested: 'Noch nicht verbunden',
    devicePermissionInfo: 'Die Berechtigung wird erst nach Tippen auf diese Schaltfläche angefragt. nosubject liest nur ausgewählte Kalender und den nötigen Zeitraum; hier werden keine Termine geschrieben.',
    selectCalendars: 'Anzuzeigende Kalender',
    noDeviceCalendars: 'Auf diesem Gerät sind keine Ereigniskalender verfügbar.',
    manageSystemPermission: 'Systemberechtigung verwalten',
    connectionPrivacyInfo: 'Die Auswahl bleibt für dieses Konto auf diesem Gerät. Externe Details werden nur in deiner Ansicht verwendet und nicht automatisch geteilt.',
    newBuildRequired: 'Für Kalenderverbindungen ist eine neuere App-Version erforderlich.',
    connectionFailed: 'Kalender konnte nicht verbunden werden.',
    disconnect: 'Verbindung trennen',
    disconnectTitle: 'Kalenderverbindung trennen?',
    disconnectBody: 'nosubject liest auf diesem Gerät keine Kalender mehr und schreibt keine neu bestätigten Termine. Auswahl und lokale Zuordnungen werden gelöscht; bestehende Systemkalender-Termine bleiben erhalten. Die Systemberechtigung kann separat in den Geräteeinstellungen widerrufen werden.',
    disconnectFailed: 'Die Kalenderverbindung konnte nicht getrennt werden.',
    selectionSaveFailed: 'Kalenderauswahl konnte nicht gespeichert werden.',
    allDay: 'Ganztägig',
    recurring: 'Wiederkehrend',
    availabilityFree: 'Frei',
    availabilityBusy: 'Belegt',
    availabilityTentative: 'Vorläufig',
    availabilityUnavailable: 'Nicht verfügbar',
    untitledExternalEvent: 'Termin ohne Titel',
    externalEventsFailed: 'Externe Kalendertermine konnten nicht geladen werden.',
    hideExternalEvent: '{title} in dieser Ansicht ausblenden',
    hideExternalEventFailed: 'Der Termin konnte nicht ausgeblendet werden.',
    restoreHiddenExternalEvents: 'Ausgeblendete Termine wieder anzeigen',
    restoreHiddenExternalEventsFailed: 'Ausgeblendete Termine konnten nicht wieder angezeigt werden.',
    hiddenExternalEventCount: '{count} Termine auf diesem Gerät ausgeblendet',
    checkIncompleteTitle: 'Kalenderprüfung unvollständig',
    checkIncompleteBody: 'Mindestens eine Kalenderquelle konnte vorübergehend nicht gelesen werden. Deshalb können wir nicht bestätigen, dass diese Zeit vollständig frei ist. Du kannst trotzdem fortfahren.',
    conflictCheckIncomplete: 'Einige Kalender konnten nicht gelesen werden; möglicherweise gibt es weitere Überschneidungen.',
    conflictTitle: 'Kalenderkonflikt',
    reservationUnavailable: 'Diese Zeit ist wegen einer anderen bestätigten Reservierung nicht mehr verfügbar.',
    reservationChanged: 'Diese Reservierung wurde auf einem anderen Bildschirm oder Gerät geändert. Die aktuelle Version wurde geladen.',
    reservationPast: 'Eine Reservierung mit vergangener Startzeit kann nicht angenommen werden.',
    conflictBody: 'Diese Zeit überschneidet sich mit einem anderen Termin in deinem Kalender. Du kannst trotzdem fortfahren.',
    tentativeConflictTitle: 'Vorläufiger Kalendertermin',
    tentativeConflictBody: 'Ein Kalendertermin zu dieser Zeit ist noch nicht bestätigt. Prüfe die Details, bevor du fortfährst.',
    conflictMore: '• Weitere Termine: {count}',
    continueAnyway: 'Trotzdem fortfahren',
    onlineCalendars: 'Online-Kalender',
    googleCalendar: 'Google Kalender',
    providerConnected: 'Verbunden',
    providerNotConnected: 'Nicht verbunden',
    providerUnavailable: 'Die offizielle Verbindung wird vorbereitet',
    googlePrivacyInfo: 'Nur die von dir ausgewählten Kalender werden synchronisiert. Titel und Orte werden in einem minimalen Server-Cache verschlüsselt; Beschreibungen, Teilnehmende und Konferenzlinks werden nicht gespeichert. nosubject kann keine Google-Kalendertermine erstellen, ändern oder löschen.',
    googleConnectionFailed: 'Die Verbindung zu Google Kalender konnte nicht gestartet werden.',
    microsoftCalendar: 'Microsoft Kalender',
    microsoftInfo: 'nosubject liest nur deine Verfügbarkeit (Calendars.Read). Termine können nicht erstellt, geändert oder gelöscht werden. Der Zugriff wird in deinen Microsoft-Kontoeinstellungen entfernt; nosubject kann ihn nicht selbst widerrufen.',
    microsoftConnectionFailed: 'Die Verbindung zu Microsoft Kalender konnte nicht gestartet werden.',
    googleDisconnectTitle: 'Google Kalender trennen?',
    googleDisconnectBody: 'nosubject greift danach nicht mehr auf Google-Kalenderdaten zu und widerruft die Google-Berechtigungen, die du nosubject erteilt hast. Termine in Google Kalender werden nicht gelöscht.',
    googleDisconnectFailed: 'Google Kalender konnte nicht getrennt werden.',
    googleNoCalendars: 'Es wurden keine lesbaren Google-Kalender gefunden.',
    googleSelectionSaveFailed: 'Die Google-Kalenderauswahl konnte nicht gespeichert werden.',
  },
  instagram: {
    title: 'Instagram-Verbindung',
    connectInfo: 'Verbinde dein professionelles Konto mit ausdrücklicher Zustimmung',
    connectedAccounts: 'Verbundene Konten',
    professionalAccount: 'Professionelles Konto',
    connect: 'Verbinden',
    reconnect: 'Neu verbinden',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Noch nicht verbunden',
    unavailable: 'Die offizielle Verbindung wird vorbereitet',
    privacyInfo: 'Im ersten Schritt wird nur instagram_business_basic zum Lesen der Identität des professionellen Kontos angefordert. Es werden keine Rechte für Nachrichten, Kommentare oder Veröffentlichungen verlangt und keine Fotos ohne separate Importauswahl zu nosubject kopiert.',
    business: 'Unternehmen',
    creator: 'Creator',
    connectionFailed: 'Die Instagram-Verbindung konnte nicht gestartet werden.',
  },
  inbox: {
    markUnread: 'Als ungelesen markieren',
    markRead: 'Als gelesen markieren',
    archiveTitle: 'Archiv',
    archive: 'Archiv',
    failed: 'Unterhaltungen konnten nicht geladen werden',
    searchEmpty: 'Keine Ergebnisse',
    archivedEmpty: 'Keine archivierten Unterhaltungen',
    empty: 'Noch keine Unterhaltungen',
    you: 'Du:',
    archived: 'Archiviert',
    unarchived: 'Aus dem Archiv geholt',
    undo: 'Rückgängig',
    mute: 'Stummschalten',
    muteTitle: '{name} stummschalten',
    mute1h: 'Für 1 Stunde',
    mute8h: 'Für 8 Stunden',
    mute1w: 'Für 1 Woche',
    muteForever: 'Unbefristet',
    unmute: 'Stummschaltung aufheben',
    archiveAction: 'Archivieren',
    unarchiveAction: 'Aus dem Archiv holen',
    swipeRemove: 'Aus dem Archiv holen',
    swipeArchive: 'Archivieren',
    blockAction: 'Blockieren',
    blockTitle: '{name} blockieren?',
    blockMessage: 'Diese Person kann dir keine Nachrichten mehr senden und dich nicht mehr in der Entdecken-Ansicht finden.',
    blockConfirm: 'Blockieren',
  },
  // 9.33.9.3 / D-780 — passkeys, named as the system names them.
  passkeys: {
    // D-882 — signing in with a passkey.
    signIn: "Mit Passkey anmelden",
    signInIntro: "Mit einem Passkey kannst du dich ohne Telefonnummer und Code anmelden.",
    signInNone: "Auf diesem Gerät gibt es keinen Passkey für nosubject. Melde dich zuerst mit deiner Telefonnummer an und füge dann einen hinzu unter Profil → Einstellungen → Anmeldemethoden → Passkeys.",
    signInFailed: "Die Anmeldung mit deinem Passkey hat nicht geklappt. Bitte versuche es erneut.",
    // D-876 — a lost passkey, reset after a 48-hour wait.
    lost: "Passkey verloren?",
    recoveryIntro: "Wenn keines deiner Geräte deinen Passkey mehr hat, kannst du ihn zurücksetzen. Nachdem du deine Nummer bestätigt hast, gibt es eine Wartezeit von 48 Stunden. Wir sagen dir in deinem Chat Bescheid, und wer deinen Passkey hat, kann das Zurücksetzen abbrechen.",
    recoveryPending: "Das Zurücksetzen ist am {date} bereit.",
    recoveryCancel: "Zurücksetzen abbrechen",
    recoveryCancelled: "Zurücksetzen abgebrochen.",
    recoveryReady: "Das Zurücksetzen ist bereit. Füge deinen neuen Passkey hinzu.",
    recoveryDone: "Dein neuer Passkey wurde hinzugefügt. Die alten funktionieren nicht mehr.",
    title: "Passkeys",
    intro: "Ein Passkey bestätigt dich so, wie du dieses Gerät entsperrst. Er bleibt auf deinem Gerät; nosubject erhält nie dein Gesicht oder deinen Fingerabdruck.",
    taskIntro: "Nachrichten an den offiziellen Account von nosubject werden vor dem Senden mit einem Passkey bestätigt.",
    empty: "Du hast noch keinen Passkey.",
    add: "Passkey hinzufügen",
    remove: "Entfernen",
    removeTitle: "Diesen Passkey entfernen?",
    removeBody: "Du bestätigst zuerst mit einem Passkey.",
    added: "Passkey hinzugefügt.",
    removed: "Passkey entfernt.",
    addedOn: "Hinzugefügt am {date}",
    lastUsed: "Zuletzt verwendet am {date}",
    unnamed: "Passkey",
    reauthIntro: "Bestätige deine hinterlegte Telefonnummer, um deinen ersten Passkey hinzuzufügen.",
    sendCode: "Bestätigungscode senden",
    codeSent: "Ein Code wurde an deine hinterlegte Nummer mit der Endung {phone} gesendet.",
    codeLabel: "Bestätigungscode",
    startAgain: "Neu beginnen",
    wrongCode: "Dieser Code hat nicht funktioniert. Fordere einen neuen an.",
    failed: "Die Anfrage konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
    exists: "Dieses Gerät hat bereits einen Passkey für deinen Account.",
    unsupportedApp: "Diese Version der App kann noch keine Passkeys verwenden. Das kommt mit dem nächsten App-Update.",
    unsupportedWeb: "Dieser Browser kann keine Passkeys verwenden.",
    tapTitle: "Mit deinem Passkey fortfahren",
    tapAction: "Fortfahren",
  },
  message: {
    jumpLatest: 'Zur neuesten Nachricht',
    info: "Nachrichteninfo",
    infoSentAt: "Gesendet",
    infoReadAt: "Gelesen",
    infoPlatform: "Gesendet über",
    // 9.33.9.4 — a message to the task chat stopped for its passkey.
    passkeyNeededTitle: "Füge zuerst einen Passkey hinzu",
    passkeyNeededBody: "Nachrichten an diesen Account werden mit einem Passkey bestätigt. Füge einen hinzu und sende dann erneut.",
    passkeyUnavailable: "Diese Nachricht braucht deinen Passkey, den diese Version der App noch nicht verwenden kann. Sende die Nachricht über nosubject.co oder nach dem nächsten App-Update.",
    passkeyFailed: "Die Nachricht konnte nicht bestätigt werden und wurde daher nicht gesendet.",
    forwardOwn: "Weiterleiten",
    forwardHint: "Wähle einen Chat. Der Text wird als Entwurf geöffnet; Senden und Bestätigung des aktuellen Preises erfolgen separat.",
    forwardMediaHint: "Wähle einen Chat. Ein eigener Medienentwurf wird geöffnet; prüfe den Preis und tippe auf Senden. Beschreibung und Standort werden nicht kopiert.",
    forwardMediaWaiting: "Die Vorbereitung ist noch nicht bestätigt. Erneutes Versuchen prüft denselben Vorgang und sendet keine Nachricht.",
    forwardMediaUnavailable: "Der Medienvorgang konnte nicht bestätigt werden. Prüfe den Chat, bevor du erneut sendest.",
    forwardEmpty: "Keine weiteren aktiven Chats.",
    forwardDraftFirst: "Sende oder lösche zuerst deinen aktuellen Entwurf.",
    translationLanguage: "Übersetzungssprache",
    chooseTranslationLanguage: "Zielsprache wählen",
    languageSuggestion: "Vorschlag der Gerätesprache",
    translationLanguageInfo: "Diese private Einstellung gilt für Übersetzungen in allen deinen Unterhaltungen und erscheint nicht in deinem Profil.",
    photoCaption: "Bildunterschrift hinzufügen…",
    removePhoto: "Foto entfernen",
    star: "Nachricht markieren",
    unstar: "Markierung entfernen",
    starred: "Markierte Nachrichten",
    noStars: "Keine markierten Nachrichten in diesem Chat.",
    starFailed: "Markierungen konnten nicht aktualisiert werden. Bitte erneut versuchen.",
    starredAttachment: "Nachricht mit Anhang",
    edit: "Nachricht bearbeiten",
    edited: "Bearbeitet",
    editInfo: "Du kannst bearbeiten, bis die Nachricht gelesen wurde, auch ohne Lesebestätigungen. Verschwindet Bearbeiten, kann das den Lesestatus verraten. Ungelesen heißt nicht ungesehen: Der ursprüngliche Text könnte in einer Benachrichtigung sichtbar gewesen sein. Bearbeiten garantiert nicht, Gesagtes zurückzunehmen.",
    editFailed: "Die Änderung konnte nicht bestätigt werden. Die Nachricht wurde möglicherweise gelesen oder geändert. Prüfe den Chat vor einem erneuten Versuch.",
    copy: "Kopieren",
    copyFailed: "Die Nachricht konnte nicht kopiert werden. Bitte versuche es erneut.",
    inputPlaceholder: 'Nachricht schreiben…',
    typing: 'Schreibt',
    translate: 'Übersetzen',
    withdrawn: 'Nachricht zurückgezogen',
    linkOpenTitle: 'Link öffnen',
    linkOpenBody: 'Das führt dich zu {host}. Den Link hat dir die Person geschickt, die dir schreibt — sei vorsichtig, wenn du sie nicht kennst.',
    linkOpenConfirm: 'Öffnen',
    linkOpenFailed: 'Der Link konnte nicht geöffnet werden.',
    seenAt: 'Gesehen {time}',

    priceChangedTitle: 'Der Preis hat sich geändert',
    priceChangedBody: 'Diese Nachricht kostet jetzt {new} statt {old}. Trotzdem senden?',
    priceChangedSend: 'Senden',
    priceNoticeTitle: 'Was ein Gespräch mit dieser Person kostet',
    priceNoticeMessage: '{amount} pro Nachricht',
    priceNoticeCall: 'Anrufe {amount}',
    priceNoticePersonal: 'Diese Preise wurden eigens für dich festgelegt.',
    priceDecreasedTitle: "Nachrichtenpreis gesunken",
    priceDecreasedBody: "Nachrichten kosten jetzt {new} statt {old}. Für den niedrigeren Preis ist keine Zustimmung nötig.",
    priceChange: {
      free: 'kostenlos',
    },
    expired: 'abgelaufen, erstattet',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'übers Web',
    linkViewLabel: 'Linkansicht',
    linkViewPlain: 'Einfache Adresse',
    linkViewCompact: 'Kompakt',
    linkViewCard: 'Große Karte',
    linkPreviewLoading: 'Vorschau wird erstellt…',
    linkPreviewFailed: 'Für diesen Link gibt es keine Vorschau; er wird als einfache Adresse gesendet.',
    linkPreviewA11y: 'Link: {title}, {host}',
    customPrice: 'Individueller Preis',
    priceUsesGeneral: 'Mein allgemeiner Preis gilt',
    priceRemove: 'Aus Kontakten entfernen',
    priceRemoveTitle: '{name} aus deinen Kontakten entfernen?',
    priceRemoveBody: 'Der individuelle Preis entfällt und für {name} gilt wieder dein allgemeiner Preis. Wenn dir nur Kontakte schreiben dürfen, kann diese Person kein neues Gespräch mehr beginnen. Das ist keine Sperre.',
    priceRemoveConfirm: 'Entfernen',
    priceRemoved: 'Für {name} gilt wieder dein allgemeiner Preis.',
    pricePrompt: 'Preise für {name} (0 = kostenlos):',
    saved: 'Gespeichert',
    priceFreeSet: '{name} kann dir jetzt kostenlos schreiben.',
    priceSet: 'Preis für {name} auf {price} festgelegt.',
    saveError: 'Konnte nicht gespeichert werden.',
    photoError: 'Foto konnte nicht gesendet werden.',
    noConnection: 'Keine Verbindung',
    checkInternet: 'Überprüfe deine Internetverbindung.',
    sendError: 'Nachricht konnte nicht gesendet werden.',
    addAttachment: 'Anhang hinzufügen',
    sendMessageAction: 'Nachricht senden',
    lowBalanceTitle: 'Guthaben reicht nicht aus',
    lowBalanceBody: 'Dein Guthaben liegt unter dem Nachrichtenpreis dieser Person. Lade Guthaben auf und versuche es erneut.',
    reply: 'Antworten',
    reactionA11y: '{emoji}-Reaktion, {count} insgesamt',
    reactionA11yMine: '{emoji}-Reaktion, {count} insgesamt, deine eingeschlossen',
    reactionAdd: 'Mit {emoji} reagieren',
    moreReactions: 'Weitere Emojis',
    reactionRemove: 'Deine {emoji}-Reaktion entfernen',
    you: 'Du',
    photo: '📷 Foto',
    takePhoto: 'Foto aufnehmen',
    choosePhoto: 'Aus der Galerie wählen',
    chooseVideo: 'Video auswählen',
    recordVoice: 'Sprachnachricht',
    micPermissionTitle: 'Mikrofonzugriff erforderlich',
    micPermissionBody: 'Für eine Sprachnachricht wird Zugriff auf das Mikrofon benötigt.',
    voiceError: 'Sprachnachricht konnte nicht gesendet werden',
    voiceRecording: 'Aufnahme läuft',
    videoTooLarge: 'Video ist zu groß (maximal 1 GB)',
    videoTooLong: 'Video ist zu lang (maximal 10 Minuten)',
    videoError: 'Video konnte nicht gesendet werden',
    videoNeedsUpdate: 'Aktualisiere die App, um dieses Video anzusehen',
    voiceNeedsUpdate: 'Aktualisiere die App, um diese Sprachnachricht abzuspielen',
    voiceOrderTitle: 'Sprachnachricht bestellt',
    encrypted: 'Verschlüsselte Nachricht',
    identityChanged: 'Der Sicherheitsschlüssel dieser Person hat sich geändert. Meist bedeutet das ein neues Telefon oder eine neu installierte App.',
    identityChangedVerify: 'Du hattest diesen Chat verifiziert; vergleiche die Sicherheitsnummer erneut.',
    unencrypted: 'Dieser Chat ist nicht verschlüsselt',
    unencryptedPeerInfo: 'Die App der anderen Person unterstützt noch keine Ende-zu-Ende-Verschlüsselung. Was du hier schreibst, wird deshalb unverschlüsselt gesendet und kann auf dem Server von nosubject gelesen werden. Sobald die andere Person die App aktualisiert, werden neue Nachrichten automatisch verschlüsselt.',
    unencryptedOfficialInfo: 'Das ist das offizielle Konto von nosubject. Was du hier schreibst, wird unverschlüsselt gesendet und kann vom nosubject-Team gelesen werden.',
    unencryptedSelfInfo: 'Auf diesem Gerät konnte die Verschlüsselung nicht eingeschaltet werden (zum Beispiel kann ein privates Browserfenster keine Schlüssel speichern). Was du von hier sendest, ist unverschlüsselt und kann auf dem Server von nosubject gelesen werden.',
    notificationOfferEnable: 'Benachrichtigungen einschalten',
    notificationOfferEnabled: 'Benachrichtigungen sind an',
    voiceOrderPending: 'Warten auf Lieferung',
    voiceOrderDelivered: 'Geliefert',
    voiceOrderDeclined: 'Abgelehnt, erstattet',
    voiceOrderExpired: 'Abgelaufen, erstattet',
    voiceOrderAction: 'Sprachnachricht bestellen',
    voiceOrderPick: 'Wie lang soll die Aufnahme sein?',
    voiceOrderInsufficient: 'Dein Guthaben reicht für diese Bestellung nicht.',
    voiceOrderError: 'Die Bestellung konnte nicht aufgegeben werden.',
    voiceOrderRecord: 'Aufnehmen und senden',
    voiceOrderDecline: 'Ablehnen',
    voiceOrderDeclineTitle: 'Bestellung ablehnen',
    voiceOrderDeclineBody: 'Der gesamte reservierte Betrag geht an die bestellende Person zurück.',
    voiceOrderDeclineError: 'Die Bestellung konnte nicht abgelehnt werden.',
    voiceOrderDeliverError: 'Die Aufnahme konnte nicht geliefert werden.',
    voiceOrderRecording: 'Bestellte Aufnahme',
    voiceOrderRemaining: 'Noch {length}',
    voiceOrderShortNote: 'Sendest du eine kürzere, wird nur das Aufgenommene bezahlt.',
    voiceOrderRefunded: '{amount} erstattet',
    sendLocation: 'Standort senden',
    locationTitle: 'Standort',
    locationError: 'Standort konnte nicht gesendet werden',
    shareLiveLocation: 'Live-Standort teilen',
    liveLocationHour: '1 Stunde',
    liveLocationEightHours: '8 Stunden',
    liveLocationOpenEnded: 'Bis ich ihn stoppe',
    liveLocationSharing: 'Dein Live-Standort wird geteilt',
    liveLocationStop: 'Stoppen',
    liveLocationError: 'Live-Standort konnte nicht gestartet werden',
    liveLocationCardTitle: 'Live-Standort',
    liveLocationCardActive: 'Wird gerade geteilt',
    liveLocationCardEnded: 'Teilen beendet',
    liveLocationOpen: 'Standort ansehen',
    liveLocationNoPoint: 'Noch keine Position',
    liveLocationOpenInMaps: 'In Karten öffnen',
    locationMapError: 'Die Karte konnte nicht geöffnet werden.',
    liveLocationUpdatedAgo: '{ago} aktualisiert',
    videoShort: '🎬 Video',
    voiceShort: '🎙 Sprachnachricht',
    liveLocationWatchedAgo: 'Vor {ago} angesehen',
    liveLocationNotWatched: 'Noch nicht angesehen',
    liveLocationSharerSeesYou: 'Die andere Person sieht, wann du hinschaust',
    cameraPermissionTitle: 'Kamerazugriff erforderlich',
    cameraPermissionBody: 'Erlaube den Kamerazugriff, um ein Foto aufzunehmen.',
    cameraError: 'Die Kamera konnte nicht geöffnet werden.',
    photoLocationTitle: 'Foto-Standort',
    photoLocationPromptFile: '{place} wurde aus der Fotodatei gelesen. Diesen Standort beim Foto anzeigen?',
    photoLocationPromptCapture: 'Der Gerätestandort ergab {place}. Diesen Standort beim Foto anzeigen?',
    photoLocationHide: 'Ohne Standort senden',
    photoLocationShare: 'Mit Standort senden',
    photoLocationFromFile: 'Aus Datei gelesen',
    photoLocationFromCapture: 'Gerätestandort',
    photoLocationHideAfter: 'Standort ausblenden',
    photoLocationShowAfter: 'Standort anzeigen',
    photoLocationUpdateError: 'Der Foto-Standort konnte nicht aktualisiert werden.',
  },
  versionNotice: {
    title: 'Eine neue Version ist da',
    body: 'Aktualisiere die App für Sicherheit und neue Funktionen.',
    update: 'Aktualisieren',
  },
  notifications: {
    title: 'Mitteilungen',
    cardBody: 'Aktiviere Gerätemitteilungen, damit du keine neuen Nachrichten und Antworten verpasst.',
    notNow: 'Jetzt nicht',
    enable: 'Mitteilungen aktivieren',
    device: 'Gerätemitteilungen',
    stateOn: 'Ein · In Systemeinstellungen verwalten',
    stateOff: 'Aus · In Systemeinstellungen aktivieren',
    stateAsk: 'Noch nicht gefragt',
    preferences: 'Mitteilungseinstellungen',
    preferencesInfo: 'Kategorien, Vorschau und Geräteberechtigung verwalten',
    stateUnsupported: 'Auf diesem Gerät nicht unterstützt',
    master: 'Alle Mitteilungen',
    masterInfo: 'Wenn diese Option ausgeschaltet ist, erhältst du keine Push-Mitteilungen mehr. Die Kategorieeinstellungen bleiben erhalten',
    categories: 'Kategorien',
    categoryEnabled: 'Mitteilungen dieser Kategorie',
    categoryEnabledInfo: 'Wenn diese Option ausgeschaltet ist, erhältst du keine Push-Mitteilungen aus dieser Kategorie mehr. Die gewählten Einstellungen bleiben erhalten',
    events: 'Ereignisse',
    messages: 'Nachrichten',
    messagesInfo: 'Neue Nachrichten und Antworten',
    meetups: 'Treffen',
    meetupsInfo: 'Vorschläge, Änderungen und Ergebnisse',
    meetupRequests: 'Neue Treffenvorschläge',
    meetupRequestsInfo: 'Wenn dir jemand ein neues Treffen vorschlägt',
    meetupUpdates: 'Antworten und Absagen',
    meetupUpdatesInfo: 'Wenn ein Treffen angenommen, abgelehnt oder abgesagt wird',
    meetupReminders: 'Treffenerinnerungen',
    meetupRemindersInfo: 'Wenn ein angenommenes Treffen bevorsteht',
    calls: 'Anrufe',
    callsInfo: 'Eingehende, geplante und verpasste Anrufe',
    incomingCalls: 'Eingehende Anrufe',
    incomingCallsInfo: 'Ein Tonsignal, wenn dich jemand anruft',
    callRequests: 'Vorschläge für geplante Anrufe',
    callRequestsInfo: 'Wenn ein Vorschlag erstellt, angenommen, abgelehnt oder abgesagt wird',
    callReminders: 'Anruferinnerungen',
    callRemindersInfo: 'Wenn ein angenommener Anruf bevorsteht',
    missedCalls: 'Verpasste Anrufe',
    missedCallsInfo: 'Wenn du einen Anruf nicht annehmen konntest',
    financial: 'Geld und Treuhand',
    financialInfo: 'Änderungen am Transaktionsstatus',
    financialEarnings: 'Einnahmen und Treuhand',
    financialEarningsInfo: 'Wenn Treuhand freigegeben wird oder Einnahmen verfügbar sind',
    financialRefunds: 'Erstattungen und Ablauf',
    financialRefundsInfo: 'Wenn eine Zahlung erstattet wird oder die Treuhand abläuft',
    financialPayouts: 'Auszahlungsergebnisse',
    financialPayoutsInfo: 'Wenn eine Auszahlung erfolgreich ist oder fehlschlägt',
    reactions: 'Emoji-Reaktionen',
    reactionsInfo: 'Reaktionen auf deine Nachrichten',
    official: 'Von Nosubject',
    officialInfo: 'Mitteilungen von Nosubject zu Versionen, Sicherheit und deinem Konto. Unabhängig von deinen anderen Benachrichtigungen; schaltest du sie aus, sendet Nosubject keine Benachrichtigungen, die Nachrichten kommen aber weiter in deinem Posteingang an.',
    preview: 'Nachrichtenvorschau',
    previewHidden: 'Ausgeblendet',
    previewHiddenInfo: 'Weder Absender noch Nachricht anzeigen',
    previewSender: 'Nur Absender',
    previewSenderInfo: 'Absender zeigen, Nachricht ausblenden',
    previewText: 'Absender und Nachricht',
    previewTextInfo: 'Bis zu 80 Zeichen anzeigen',
    deviceInfo: 'Die Systemberechtigung gilt nur für dieses Gerät',
    openSettings: 'Einstellungen öffnen',
    centerTitle: 'Mitteilungszentrale',
    centerMarkAll: 'Alle als gelesen markieren', centerMarkedAll: 'Alle als gelesen markiert',
    centerEmpty: 'Noch keine Mitteilungen.',
    centerFailed: 'Mitteilungen konnten nicht geladen werden.',
    centerMarkAllFailed: 'Mitteilungen konnten nicht als gelesen markiert werden.',
    centerUnknownPerson: 'Jemand',
    centerEscrowExpiredRefunded: 'Treuhand abgelaufen · Zahlung erstattet',
    centerEscrowReleasedEarning: 'Antwort abgeschlossen · Einnahmen gutgeschrieben',
    centerMeetupRequest: '{name} hat dir ein Treffen vorgeschlagen',
    centerCallRequest: '{name} hat dir einen geplanten Anruf vorgeschlagen',
    centerCallReminder: 'Dein geplanter Anruf mit {name} steht an',
    centerCallStarting: 'Dein geplanter Anruf mit {name} beginnt',
    centerMeetupStarting: 'Dein Treffen mit {name} beginnt',
    centerMeetupReminder: 'Dein Treffen mit {name} steht an',
    centerMeetupUpdate: '{name} · Treffen: {status}',
    centerCallUpdate: '{name} · Geplanter Anruf: {status}',
    centerMeetupRescheduleRequest: '{name} hat eine neue Treffzeit vorgeschlagen',
    centerCallRescheduleRequest: '{name} hat eine neue Anrufzeit vorgeschlagen',
    centerMeetupRescheduleUpdate: '{name} · Neue Treffzeit: {status}',
    centerCallRescheduleUpdate: '{name} · Neue Anrufzeit: {status}',
    centerBell: 'Mitteilungszentrale',
    centerBellUnread: 'Mitteilungszentrale, ungelesen: {count}',
  },
  profile: {
    viewPhoto: "Profilfoto ansehen",
    photoUnavailable: "Dieses Foto konnte nicht geladen werden.",
    // 9.35.3 · D-830 — profile photos and videos.
    photos: "Fotos",
    mediaPhotoLabel: "Foto {n} von {total}",
    mediaVideoLabel: "Video {n} von {total}",
    mediaUnavailable: "Die Fotos konnten nicht geladen werden",
    mediaMore: "Mehr anzeigen",
    // 9.35.4 · D-830 — removing one's own photo or video.
    mediaRemove: "Aus dem Profil entfernen",
    mediaRemovePhotoTitle: "Dieses Foto aus deinem Profil entfernen?",
    mediaRemoveVideoTitle: "Dieses Video aus deinem Profil entfernen?",
    mediaRemoveBody: "Die Datei wird gelöscht und kann nicht wiederhergestellt werden.",
    mediaRemoveFailed: "Entfernen fehlgeschlagen. Versuch es noch einmal.",
    webVisibility: 'Wer meine Webseite sehen kann',
    webVisibilityLink: 'Mit Link',
    webVisibilityInfo: 'Dein Profil, wie Menschen ohne Konto es sehen: deine Seite nosubject.co/dein-benutzername. Alle: Die Seite kann auch in Suchmaschinen erscheinen. Mit Link: Wer die Adresse hat, kann sie öffnen; Suchmaschinen listen sie nicht. Bei beiden können Menschen ohne Konto deine Profilangaben abrufen, auch wann du zuletzt online warst. Niemand: Niemand ohne Konto kann dein Profil sehen; die Seite zeigt „Dieses Profil ist nicht verfügbar“. Dein Profil in der App ändert sich nicht. Bis sie aus den Suchergebnissen verschwindet, kann es einige Tage dauern.',
    linkViewInfo: 'Lege fest, wie ein Link gesendet wird, den du schreibst. Bei Kompakt und Große Karte öffnet dein Telefon die Seite einmal und sendet die Vorschau mit der Nachricht; diese Website sieht die IP-Adresse deines Telefons. In einem verschlüsselten Chat liegt die Vorschau in der Verschlüsselung; in einem unverschlüsselten Chat sieht nosubject den Link und die Vorschau. Einfache Adresse öffnet keine Seite. Links aus dem Web gehen immer als einfache Adresse.',
    linkViewAsk: 'Optionen beim Schreiben zeigen',
    linkViewAskInfo: 'Wenn aktiviert, erscheinen beim Schreiben eines Links die beiden anderen Ansichten, und du kannst eine für diese Nachricht wählen. Wenn deaktiviert, gehen Links immer in der hier gewählten Ansicht.',
    whoCanCallInfo: 'Lege fest, wer dich anrufen darf; das gilt für jeden Anruf. Meine Kontakte sind die Personen, denen du einen persönlichen Preis gegeben hast. Unter Ausnahmen kannst du einzelne Personen zulassen oder sperren.',
    whoCanMessageInfo: 'Lege fest, wer eine neue Unterhaltung mit dir beginnen darf; bereits begonnene Unterhaltungen bleiben unverändert. Meine Kontakte sind die Personen, denen du einen persönlichen Preis gegeben hast. Unter Ausnahmen kannst du einzelne Personen zulassen oder sperren.',
    readReceiptsInfo: "Lesebestätigungen erscheinen nur, wenn beide sie aktivieren. Auch ausgeschaltet kann das Verschwinden von Bearbeiten verraten, dass die Nachricht gelesen wurde.",
    showTypingInfo: 'Wenn aktiviert, sieht die Person, der du schreibst, dass du gerade tippst. Schaltest du es aus, sieht es niemand, und du siehst weiterhin, wenn andere tippen.',
    officialAccount: 'Offizielles Konto',
    information: 'Profilinformationen',
    logout: 'Abmelden',
    account: 'Konto',
    accountData: 'Konto & Daten',
    name: 'Vorname',
    surname: 'Nachname',
    username: 'Benutzername',
    usernamePlaceholder: 'benutzername',
    usernameChecking: 'Wird geprüft…',
    usernameAvailable: 'Verfügbar',
    usernameTaken: 'Dieser Benutzername ist bereits vergeben',
    usernameInvalid: '3–20 Zeichen. Beginne mit A–Z oder a–z; danach sind A–Z, a–z, 0–9 oder _ erlaubt.',
    usernameAdd: 'Benutzernamen hinzufügen',
    profession: 'Beruf',
    professionNone: 'Kein Beruf hinzugefügt',
    professionAdd: 'Beruf hinzufügen',
    employer: 'Unternehmen',
    employerPlaceholder: 'unternehmensbenutzername',
    employerInfo: 'Gib einen bestehenden nosubject-Benutzernamen ein. Diese Angabe bedeutet nicht, dass das Arbeitsverhältnis verifiziert ist.',
    employerNotFound: 'Kein aktives Konto mit diesem Benutzernamen gefunden.',
    employerSelf: 'Du kannst dein eigenes Konto nicht als Unternehmen angeben.',
    bio: 'Erzähl etwas über dich…',
    prices: 'Preise',
    settings: 'Einstellungen',
    priceMessage: 'Nachricht',
    priceVoice: 'Sprachnachricht (pro Minute)',
    priceVoiceShort: 'Sprachnachricht',
    priceCall: 'Sofort anrufen (pro Minute)',
    priceCallShort: 'Sofort anrufen',
    priceScheduledCall: 'Anruf planen (pro Minute)',
    priceScheduledCallShort: 'Anruf planen',
    priceVideoCall: 'Videoanruf',
    priceVideoCallShort: 'Video',
    priceTime: 'Treffen (pro Minute)',
    priceTimeShort: 'Treffen',
    currency: 'Währung',
    saving: 'Wird gespeichert…',
    wallet: 'Wallet',
    chatBackup: 'Chat-Backup',
    privacy: 'Privatsphäre',
    readReceipts: 'Lesebestätigungen',
    showTyping: 'Tippanzeige',
    keepArchived: 'Archiviert lassen',
    keepArchivedInfo: 'Wenn deaktiviert, holt eine neue Nachricht die Unterhaltung aus dem Archiv',
    whoCanMessage: 'Wer mir schreiben kann',
    whoCanCall: 'Wer mich anrufen kann',
    messagesFromContact: 'Nachrichten von dieser Person',
    callsFromContact: 'Anrufe von dieser Person',
    callExceptions: 'Ausnahmen',
    callExceptionsEmpty: 'Noch keine Anrufausnahmen',
    messageExceptionsEmpty: 'Noch keine Ausnahmen für Nachrichten',
    exceptionsLoadFailed: 'Ausnahmen konnten nicht geladen werden',
    openProfileHint: 'Öffnet das Profil dieser Person',
    callExceptionBlocked: 'Blockiert',
    callsFromContactDefault: 'Standard',
    callsFromContactAllow: 'Immer erlauben',
    callsFromContactBlock: 'Nie',
    everyone: 'Alle',
    contacts: 'Meine Kontakte',
    nobody: 'Niemand',
    blockedUsers: 'Blockierte Nutzer',
    blockedEmpty: 'Du hast niemanden blockiert',
    unblock: 'Blockierung aufheben',
    appearance: 'Erscheinungsbild',
    light: 'Hell',
    dark: 'Dunkel',
    system: 'System',
    displayLanguage: 'App-Sprache',
    education: 'Universität',
    educationAdd: 'Universität hinzufügen',
    educationNone: 'Keine Universität hinzugefügt',
    educationLevel: 'Abschluss',
    searchLanguage: 'Sprache suchen…',
    photoChange: 'Ändern',
    saveFailed: 'Konnte nicht gespeichert werden.',
    photoFailed: 'Foto konnte nicht hochgeladen werden.',
    photoChanged: "Das Foto wurde durch einen anderen Vorgang geändert oder die Frist zum erneuten Versuch ist abgelaufen. Wähle das Foto bitte erneut aus.",
    deleteAccount: 'Konto löschen',
    deleteTitle: 'Dein Konto löschen',
    deleteMessage: 'Dein Konto wird nach 30 Tagen endgültig gelöscht. Du kannst dich in diesem Zeitraum wieder anmelden, um das abzubrechen.',
    deleteMoneyWarning: 'Du hast insgesamt {amount} in deiner Wallet und auf dem Treuhandkonto. Wir empfehlen, den Betrag vor dem Löschen auszahlen zu lassen.',
    deleteConfirm: 'Löschen',
    deleteFailed: 'Konto konnte nicht gelöscht werden.',
    deletionScheduled: 'Dein Konto wird am {date} gelöscht.',
    deletionCancel: 'Löschung abbrechen',
    exportData: 'Meine Daten herunterladen',
    exportFailed: 'Daten konnten nicht abgerufen werden.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Anrufe',
    discover: 'Entdecken',
    inbox: 'Nachrichten',
    calendar: 'Kalender',
    profile: 'Profil',
    unreadMessages: 'ungelesen: {count}',
    pendingRequests: 'offen: {count}',
  },
  // 9.18.10.4 · D-830 — importing one's own Instagram download.
  instagramImport: {
    title: "Aus Instagram importieren",
    addEntry: "Aus Instagram importieren",
    guideIntro: "Lade deine eigenen Instagram-Daten herunter und wähle sie hier aus, um deine Fotos und Videos deinem Profil hinzuzufügen.",
    guideStep1: "Geh in Instagram zur Kontenübersicht → Deine Informationen und Berechtigungen → Deine Informationen herunterladen.",
    guideStep2: "Wähle unter „Einige deiner Informationen“ nur Inhalte; Format JSON, Medienqualität Hoch.",
    guideStep3: "Wenn Meta die Datei vorbereitet hat, lade sie herunter und wähle sie hier aus.",
    guideOwnOnly: "Nur Fotos und Videos, die du gepostet hast, werden angezeigt; Medien aus Nachrichten werden nie übernommen.",
    guideOnDevice: "Die Datei wird auf deinem Gerät geöffnet und nie an unseren Server gesendet; nur was du auswählst, wird hochgeladen.",
    choose: "ZIP-Datei auswählen",
    reading: "Archiv wird gelesen",
    notZip: "Diese Datei ist kein ZIP-Archiv.",
    untrusted: "Dieses Archiv wirkt nicht sicher und wurde nicht geöffnet.",
    tooBig: "Dieses Archiv ist zu groß.",
    unreadable: "Dieses Archiv konnte nicht gelesen werden.",
    chooseAnother: "Andere Datei auswählen",
    noMedia: "In diesem Archiv wurden keine Fotos oder Videos gefunden, die hinzugefügt werden können.",
    found: "{count} Fotos und Videos gefunden",
    slotsLeft: "Noch {count} Plätze in deinem Profil",
    selectAll: "Alle auswählen",
    selectNone: "Auswahl aufheben",
    alreadyOnProfile: "Im Profil",
    tooLarge: "Zu groß",
    add: "{count} hinzufügen",
    adding: "{n} von {total} wird hinzugefügt",
    stop: "Stoppen",
    stopping: "Stoppt nach diesem",
    doneAdded: "{count} hinzugefügt",
    doneDuplicate: "{count} waren schon in deinem Profil",
    doneSkipped: "{count} übersprungen",
    doneFailed: "{count} konnten nicht hinzugefügt werden",
    retryFailed: "Die übrigen noch einmal versuchen",
    profileFull: "Dein Profil ist voll; es konnte nichts mehr hinzugefügt werden.",
    guideParts: "Wenn Meta deinen Download in mehrere ZIP-Teile aufgeteilt hat, wähle alle zusammen aus.",
    catAll: "Alle",
    catPosts: "Beiträge",
    catReels: "Reels",
    catStories: "Storys",
    catIgtv: "IGTV",
    catArchived: "Archiviert",
    catProfile: "Profilbilder",
    catOther: "Sonstige",
    archiveSection: "Instagram-Download",
    archiveHint: "Fügt deinem Profil die Fotos und Videos aus deinem eigenen Datendownload hinzu.",
  },
};
